import { AmountPaid } from './amount-paid';
import { AssignedTo } from './assigned-to';
import { BatchName } from './batch-name';
import { Carrier } from './carrier';
import { CarrierFee } from './carrier-fee';
import { City } from './city';
import { Company } from './company';
import { Confirmation } from './confirmation';
import { Country } from './country';
import { CreatedDate } from './created-date';
import { CustomsForms } from './customs-forms';
import { DeliveryNotification } from './delivery-notification';
import { EndOfDayForm } from './end-of-day-form';
import { Forms } from './forms';
import { Insurance } from './insurance';
import { InsuranceFee } from './insurance-fee';
import { intlDuties } from './intl-duties';
import { intlImportFees } from './intl-import-fees';
import { intlTax } from './intl-tax';
import { LabelCreated } from './label-created';
import { LabelPrinted } from './label-printed';
import { MarketplaceNotified } from './marketplace-notified';
import { OrderDate } from './order-date';
import { OrderNumber } from './order-number';
import { PackageColumn } from './package-column';
import { PackingSlipPrinted } from './packing-slip-printed';
import { PaidDate } from './paid-date';
import { PostalCode } from './postal-code';
import { Provider } from './provider';
import { Quantity } from './quantity';
import { Rate } from './rate';
import { RateShopper } from './rate-shopper';
import { Recipient } from './recipient';
import { RefundAmountRequested } from './refund-amount-requested';
import { RefundCompletedUtc } from './refund-completed-utc';
import { RefundRequestedStartUtc } from './refund-requested-start-utc';
import { RefundStatusType } from './refund-status-type';
import { RefundedAmount } from './refunded-amount';
import { ScanToVerifyStatus } from './scan-to-verify-status';
import { Service } from './service';
import { ShipDate } from './ship-date';
import { ShipFrom } from './ship-from';
import { ShipmentNotification } from './shipment-notification';
import { ShipmentNumber } from './shipment-number';
import { ShippingAccount } from './shipping-account';
import { ShippingPaid } from './shipping-paid';
import { Source } from './source';
import { State } from './state';
import { Store } from './store';
import { TaxPaid } from './tax-paid';
import { TrackingNumber } from './tracking-number';
import { VoidType } from './void-type';
import { Weight } from './weight';

export const EMAIL_COLUMN_IDS = [DeliveryNotification.id, ShipmentNotification.id];

export const REFUND_ASSIST_COLUMNS = [RefundAmountRequested, RefundCompletedUtc, RefundRequestedStartUtc, RefundedAmount, RefundStatusType];

export const VOIDED_GRID_COLUMNS = [VoidType];

export const VOIDED_GRID_COLUMN_IDS = [VoidType.id];

export const baseColumns = [
  AmountPaid,
  AssignedTo,
  BatchName,
  CarrierFee,
  Carrier,
  City,
  Company,
  Confirmation,
  Country,
  CreatedDate,
  CustomsForms,
  DeliveryNotification,
  EndOfDayForm,
  Forms,
  Insurance,
  InsuranceFee,
  intlDuties,
  intlImportFees,
  intlTax,
  LabelCreated,
  LabelPrinted,
  MarketplaceNotified,
  OrderDate,
  OrderNumber,
  PackageColumn,
  PackingSlipPrinted,
  PaidDate,
  PostalCode,
  Provider,
  Quantity,
  Rate,
  RateShopper,
  Recipient,
  ScanToVerifyStatus,
  Service,
  ShipDate,
  ShipFrom,
  ShipmentNotification,
  ShipmentNumber,
  ShippingAccount,
  ShippingPaid,
  Source,
  State,
  Store,
  TaxPaid,
  TrackingNumber,
  Weight,
];
